import { useState, useCallback } from "react";
import {
  useFetchNfe,
  useAPINFE2,
  useToast,
  useNfeAPIAuthenticate,
} from "hooks";
import { getURLWithParams } from "utils/context";
import { useAPIToast } from "hooks/useAPIToast";

// TODO: Retirar os usos de hooks com cancelamento

export const useListSuppliers = params =>
  useFetchNfe(
    params ? getURLWithParams("/business-oportunity/supplier", params) : null,
  );

export const useListSuppliersNotes = params =>
  useFetchNfe(
    params ? getURLWithParams("/business-oportunity/tax-note", params) : null,
  );

export const useListSuppliersNotesProducts = params =>
  useFetchNfe(
    params
      ? getURLWithParams("/business-oportunity/tax-note-items", params)
      : null,
  );

export const useSuppliersAll = params =>
  useFetchNfe(
    params
      ? getURLWithParams("/business-oportunity/all-supplier", params)
      : null,
  );

export const useSuppliersIgnored = (params = {}) =>
  useFetchNfe(getURLWithParams("/suppliers/ignored", params));

export const useNfIgnored = (params = {}) =>
  useFetchNfe(getURLWithParams("/tax-note/ignored", params));

export const useIgnoreSupplier = () => {
  const api = useNfeAPIAuthenticate();
  const { onSend, isLoading, data } = useAPIToast(api);

  const onIgnoreSupplier = data =>
    onSend({
      endpoint: "/suppliers/ignore",
      messageSuccess: "Fornecedor ignorado com sucesso",
      messageFail: "Falha ao tentar ignorar fornecedor",
      type: "POST",
      data,
    });

  const onUnignoreSupplier = ({ cnpjEmpresa, cnpjFornecedor }) =>
    onSend({
      endpoint: "/suppliers/ignored",
      messageSuccess: "Fornecedor removido com sucesso",
      messageFail: "Falha ao tentar remover fornecedor",
      type: "DELETE",
      data: { cnpj_empresa: cnpjEmpresa, cnpj_fornecedor: cnpjFornecedor },
    });

  return {
    onIgnoreSupplier,
    onUnignoreSupplier,
    data,
    isLoading,
  };
};

export const useExportCsv = () => {
  const apiNfe = useAPINFE2();
  const [data, setData] = useState(undefined);
  const [loading, setLoading] = useState(false);

  const { addToast } = useToast();

  const fetch = useCallback(
    (url, params = {}) => {
      setLoading(true);
      apiNfe
        .get(getURLWithParams(`/reports-exports/${url}`, params))
        .then(res => {
          if (res?.data?.response === false) {
            setLoading(false);
            return addToast({
              type: "error",
              title: "Sem dados",
              description: `Não foi encontrado dados para exportar ${url}`,
            });
          }
          window.open(res?.data?.Location, "_blank");
          setLoading(false);
        })
        .catch(() => {
          setData(undefined);
          setLoading(false);
        });
    },
    [apiNfe, addToast],
  );

  return { isLoading: loading, data, fetch };
};
